import { TerritoryModel } from './territory.model';
import { LanguageModel } from './language.model';
import { ReferentialValueModel } from './referential-value.model';
import { AttachedFileModel } from './attached-file.model';

/**
 * Created by hbentaher on 23/08/2017.
 */
export class FSKModel {
  public id: number;
  public comments: string;
  public dateAgeRating: string;
  public lengthMeter: string;
  public workId: number;
  public lengthMinute: string;
  public lengthRuntime: string;
  public checkNumber: string;
  public restrictions: boolean;
  public indexed: boolean;
  public sundayBHA: boolean;
  public country: TerritoryModel;
  public language: LanguageModel;
  public subTitle: LanguageModel;
  public duration24: number;
  public duration25: number;
  public dateOfAgeRating: string;
  public oldLength: string;
  public provider: string;
  public ageRating: ReferentialValueModel;
  public category: ReferentialValueModel;
  public medium: ReferentialValueModel;
  public refProvider: ReferentialValueModel;
  public editorialContentId: number;
  public versionTimeStamp: string;
  public attachedFiles: AttachedFileModel[];

  constructor() {
    this.ageRating = new ReferentialValueModel();
    this.medium = new ReferentialValueModel();
    this.refProvider = new ReferentialValueModel();
    this.category = new ReferentialValueModel();
    this.attachedFiles = [];
  }

  public fromJSON(json) {
    for (const propName in json) {
      if (json.hasOwnProperty(propName)) {
        this[propName] = json[propName];
      }
    }
    return this;
  }
}
